/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      ul: "ul",
      li: "li",
      strong: "strong",
      em: "em"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Restricted Use Policy"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Use Restrictions"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsxs(_components.p, {
                    children: ["We are proud to give them a better way to work. We also recognize that however good the\nmaker’s intentions, technology can\namplify the ability to cause great harm. That’s why we’ve established this policy. We feel\nan ethical obligation to counter such harm: both in terms of dealing with instances where\nModulabs is used (and abused) to further such harm, and to state unequivocally that the\nproducts we make at Modulabs are not safe havens for people who wish to commit such harm. If\nyou have an account with any of our products, you can’t use them for any of the restricted\npurposes listed below. If we find out you are, ", _jsx(_components.a, {
                      href: "./abuse/how-we-handle",
                      children: "we will take\naction"
                    }), "."]
                  }), _jsx(_components.h2, {
                    children: "Restricted purposes"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Violence, or threats thereof"
                      }), ": If an activity qualifies as violent crime in the United\nStates or where you live, you may not use Modulabs products to plan, perpetrate, or threaten\nthat activity."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Child exploitation, sexualization, or abuse"
                      }), ": We don’t tolerate any activities that\ncreate, disseminate, or otherwise cause child abuse. Keep away and stop. Just stop."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Hate speech"
                      }), ": You cannot use our products to advocate for the extermination,\ndomination, or oppression of people."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Harassment"
                      }), ": Intimidating or targeting people or groups through repeated communication,\nincluding using racial slurs or dehumanizing language, is not welcome at Modulabs."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Doxing"
                      }), ": If you are using Modulabs products to share other peoples’ private personal\ninformation for the purposes of harassment, we don’t want anything to do with you."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Malware or spyware"
                      }), ": Code for good, not evil. If you are using our products to make or\ndistribute anything that qualifies as malware or spyware — including remote user\nsurveillance — begone."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Phishing or otherwise attempting fraud"
                      }), ": It is not okay to lie about who you are or who\nyou affiliate with to steal from, extort, or otherwise harm others."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Spamming"
                      }), ": No one wants unsolicited commercial emails. We don’t tolerate folks\n(including their bots) using Modulabs products for spamming purposes. If your emails don’t\npass muster with\n", _jsx(_components.a, {
                        href: "https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business",
                        children: "CAN-SPAM"
                      }), "\nor any other anti-spam law, it’s not allowed."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Cybersquatting"
                      }), ": We don’t like username extortionists. If you purchase a Modulabs\nproduct account in someone else’s name and then try to sell that account to them, you are\n", _jsx(_components.a, {
                        href: "https://www.law.cornell.edu/uscode/text/15/1125",
                        children: "cybersquatting"
                      }), ". Cybersquatting accounts\nare subject to immediate cancellation."]
                    }), "\n", _jsxs(_components.li, {
                      children: [_jsx(_components.strong, {
                        children: "Infringing on intellectual property"
                      }), ": You can’t use Modulabs products to make or\ndisseminate work that uses the intellectual property of others beyond the bounds of ", _jsx(_components.a, {
                        href: "https://www.copyright.gov/fair-use/more-info.html",
                        children: "fair\nuse"
                      }), "."]
                    }), "\n"]
                  }), _jsx(_components.p, {
                    children: "While our use restrictions are comprehensive, they can’t be exhaustive — it’s possible an\noffense could defy categorization, present for the first time, or illuminate a moral\nquandary we hadn’t yet considered. That said, we hope the overarching spirit is clear:\nModulabs is not to be harnessed for harm, whether mental, physical, personal or civic.\nDifferent points of view — philosophical, religious, and political — are welcome, but\nideologies like white nationalism, or hate-fueled movements anchored by oppression,\nviolence, abuse, extermination, or domination of one group over another, will not be\naccepted here."
                  }), _jsx(_components.h2, {
                    children: "How to report abuse"
                  }), _jsxs(_components.p, {
                    children: ["For cases of suspected malware, spyware, phishing, spamming, and cybersquatting, please\nalert us at ", _jsx(_components.a, {
                      href: "mailto:abuse@Modulabs.com",
                      children: "abuse@Modulabs.com"
                    }), "."]
                  }), _jsxs(_components.p, {
                    children: ["For all other cases, please let us know by emailing\n", _jsx(_components.a, {
                      href: "mailto:report@Modulabs.com",
                      children: "report@Modulabs.com"
                    }), ". If you’re not 100% sure if something\nrises to the level of our use restrictions policy, report it anyway."]
                  }), _jsxs(_components.p, {
                    children: ["Please share as much as you are comfortable with about the account, the content or behavior\nyou are reporting, and how you found it. Sending us a URL or screenshots is super helpful.\nIf you need a secure file transfer, let us know and we will send you a link. We will not\ndisclose your identity to anyone associated with the reported account. For copyright cases,\nwe've outlined extra instructions on ", _jsx(_components.a, {
                      href: "../copyright/index.md",
                      children: "how to notify us about infringement\nclaims"
                    }), "."]
                  }), _jsxs(_components.p, {
                    children: ["Someone on our team will respond within one business day to let you know we’ve begun\ninvestigating. We have published details on ", _jsx(_components.a, {
                      href: "how-we-handle/index.md",
                      children: "how we investigate use restriction\nreports"
                    }), ". We will also let you know the outcome of our investigation\n(unless you ask us not to, or we are not allowed to under law)."]
                  }), _jsxs(_components.p, {
                    children: ["*", _jsx(_components.em, {
                      children: "This policy and process applies to any product created and owned by Modulabs, LLC."
                    })]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
